import { trackError as sdkTrackError } from '@didi/webx-js'
// trackError( type, code, label, level, attrs)
const trackError = (type, label, level, msg, error) => {
  console.log(
    `${type}-${label}-${level}%c${msg}`,
    'color: red;background:yellow;',
    error
  )
  // 开发环境不上报
  if (process.env.BUILD_ENV === 'offline') {
    return
  }
  if (msg && msg.indexOf('Request aborted') > -1) {
    return
  }
  try {
    sdkTrackError(type, 'quartz-mall', label, level, error)
    // window.Omega.trackError(name, code, msg, error)
  } catch (error) {}
}

export const MASErrorTrackCreateOrderFailed = (msg, error) =>
  trackError('OtherError', '商城下单失败', 2, msg, error)

export const MASErrorTrackAlgorithmTrackError = (msg, error) =>
  trackError('OtherError', '算法埋点错误', 2, msg, error)

export const MASErrorTrackLoadGoodsListError = (msg, error) =>
  trackError('DataError', '加载商品错误', 2, msg, error)

export const MASErrorTrackGetUserInfoError = (msg, error) =>
  trackError('LoginError', '获取用户信息错误', 2, msg, error)

export const MASErrorTrackSwitchUserError = (msg, error) =>
  trackError('LoginError', '切换账号错误', 2, msg, error)

export const MASErrorTrackLoadOrderListError = (msg, error) =>
  trackError('DataError', '订单获取错误', 2, msg, error)

export const MASErrorTrackNoFromQueryInMP = (msg, error) =>
  trackError('OtherError', '小程序内来源缺少 from', 2, msg, error)

export const MASErrorTrackMismatchedXENVInMP = (msg, error) =>
  trackError('OtherError', '小程序内 xenv 错误', 2, msg, error)

export const MASErrorTrackGeoCoordinateError = (msg, error) =>
  trackError('OtherError', 'URL 参数经纬度不全', 2, msg, error)

export const MASErrorTrackVisitedOldIndex = (msg, error) =>
  trackError('OtherError', '商城首页PV错误，访问旧首页', 2, msg, error) // 这个不在 js 里调用，埋在 ejs 里的，但是放在这里占位

export const MASErrorTrackIndexHomePageError = (msg, error) =>
  trackError('DataError', '商城首页 Home 接口访问失败', 2, msg, error)

export const MASErrorTrackLoadGoodInfoError = (msg, error) =>
  trackError('DataError', '加载商品信息错误', 2, msg, error)

export const MASErrorTrackCancelOrderError = (msg, error) =>
  trackError('OtherError', '订单取消失败', 2, msg, error)

export const MASErrorTrackCityIdError = (msg, error) =>
  trackError('OtherError', 'cityid不对', 2, msg, error)

export const MASErrorTrackGoodsInfoError = (msg, error) =>
  trackError('DataError', '商品详情失败', 2, msg, error)

export const MASErrorTrackGetDoingInfoError = (msg, error) =>
  trackError('DataError', '团信息失败', 2, msg, error)

// export const MASErrorTrackGroupRollingError = (msg, error) =>
//   trackError('DataError', '团rolling失败', 2, msg, error)

export const MASErrorTrackPersonalIdsError = (msg, error) =>
  trackError('OtherError', '订单列表商品多个商品id拼接错误', 0, msg, error)

export const MASErrorTrackTransformUrl = (msg, error) =>
  trackError('OtherError', '商品链接转换异常，有额外链接需处理', 2, msg, error)
